module.exports = __webpack_public_path__ + "app/img/home_11@2x.7d9300b9.png";